export class ChannelChange {
  newChannelId: string;
  newChannelName: string;
  oldChannelName: string;
}
